
import { Link } from 'react-router-dom';
import TranslateStatic from '../../locales/TranslateStatic';
import S from './style'

export function Cookie() {
  return (
    <S.Wrapper>
      {/* <S.Top>
        <S.Header>
          Çerez Politikamız
        </S.Header>
        <S.Span>
          <Link to="./">Ana Sayfa</Link> > Çerez Politikamız
        </S.Span>
      </S.Top> */}
      {/* <S.Sertifika>
        <Certification />
      </S.Sertifika> */}
      <S.Section>
        <h1><TranslateStatic string="CookiePage1" /></h1>
        <p><TranslateStatic string="CookiePage2" /></p>
        <p>
          <TranslateStatic string="CookiePage3" />
        </p>
        <p>
          <TranslateStatic string="CookiePage4" />
        </p>
        <h2> <TranslateStatic string="CookiePage5" /></h2>
        <p>
          <TranslateStatic string="CookiePage6" />
        </p>
        <p>
          <TranslateStatic string="CookiePage7" />
        </p>
        <h3><TranslateStatic string="CookiePage8" /></h3>
        <p>
          <TranslateStatic string="CookiePage9" />
        </p>
        <h3> <TranslateStatic string="CookiePage10" /></h3>
        <p>
          <TranslateStatic string="CookiePage11" />
        </p>
        <h3>
          <TranslateStatic string="CookiePage12" />
        </h3>
        <p>
          <TranslateStatic string="CookiePage13" />
        </p>
        <h3>
          <TranslateStatic string="CookiePage14" />
        </h3>
        <p>
          <TranslateStatic string="CookiePage15" />
        </p>
        <h2><TranslateStatic string="CookiePage16" /></h2>
        <p>
          <TranslateStatic string="CookiePage17" />
        </p>
        <h2> <TranslateStatic string="CookiePage18" /></h2>
        <p>
          <TranslateStatic string="CookiePage19" />
        </p>
        <h2> <TranslateStatic string="CookiePage20" /></h2>
        <p>
         <TranslateStatic string="CookiePage21" />
        </p>

      </S.Section>
    </S.Wrapper>
  );
}
